import { BaseAnalytics } from '@r1-frontend/analytics/dataLayerPush';

class CreateAgreementAnalytics extends BaseAnalytics {
    constructor(category: string) {
        super();
        this.category = category;
    }

    try() {
        this.send('create_agreement_api', 'Попытка создания договора');
    }

    success(agreementNumber: number | null, comment: string) {
        this.send('create agreement', `success: ${agreementNumber} ${comment}`);
    }

    fail(error: string, comment: string) {
        this.send('create agreement', `error: ${error} ${comment}`);
    }

    double(agreementNumber: number | null, comment: string) {
        this.send('create agreement', `double: ${agreementNumber} ${comment}`);
    }

    promocodeActivation(label: string) {
        this.send('promocode_activation', label);
    }
}

export default CreateAgreementAnalytics;
